import { withStyle } from 'styletron-react';
import { StyledLayoutBase, layoutBasePropsToStyledProps } from './LayoutBase';
export const StyledPositionLayoutBase = withStyle(StyledLayoutBase, (p) => ({
    top: p.$top,
    right: p.$right,
    bottom: p.$bottom,
    left: p.$left,
}));
export const positionLayoutBasePropsToStyledProps = ({ top, right, bottom, left, ...layoutBaseProps }) => ({
    ...layoutBasePropsToStyledProps(layoutBaseProps),
    $top: top,
    $right: right,
    $bottom: bottom,
    $left: left,
});
